<template>


  
      

    <div  :style=" ' min-height:'+(screenHeight)+'px ; '  "  id='index'  >
        <!-- border:1px solid #071018; -->
        
        <el-row  style="height:20px; " >  
            <!-- <el-col style="height:80px; "  :span="18"> 
            
                <el-button slot="append"  type="primary" icon="el-icon-search" @click="SearchEvent" >搜索</el-button>
           
            </el-col>  
         
            <el-col style="height:80px;  line-height:80px;  "  :span="6" class="hidden-sm-and-down">
                <el-input placeholder="搜工具" v-model="search_word"  style="width:90% "     @keyup.enter.native="SearchEvent"></el-input>
          
            </el-col>   -->

        </el-row>
 
         
        

        <el-row  class="mainbox1" :style="'min-height:'+screenHeight+'px' " :gutter="10">

          

           <el-col :span="4"   class="leftside1 "   :style="'min-height:'+screenHeight+'px'  "  >
                <!-- hidden-md-and-down -->

               <div class="left_wrap">
                    <div class="left_insidebox"  >
                      
                        <!-- <el-divider style="margin-top:10px"></el-divider> -->
                        <!-- @open="handleOpen" @close="handleClose"  -->
                        <!-- <h2>过滤条件</h2> -->
                        <!-- :collapse="isCollapse" -->
                        <!-- style="background-color: #f6f8fa" -->

                        <el-menu
                            style="width:100%; "
                            unique-opened
                            default-active="1"
                            class="el-menu-vertical-demo"
                            @select="handleSelect"
                            :default-openeds="opends" 
                           >
                            <el-submenu index="1"  >
                                <template slot="title">
                                <i class="el-icon-star-on"></i>
                                <span>官方工具</span>
                                </template>
                         
                                <el-menu-item-group style="padding-top:0px; ">
                                    <!-- <template slot="title">分组一</template> -->
                             
                                    <el-menu-item index="cals"  style="margin-top:-15px; ">司法计算器</el-menu-item>

                                    <el-menu-item index="search_tools">查询与检索</el-menu-item>
                                    <el-menu-item index="filehandle">文件处理</el-menu-item>
                                    <!-- <el-menu-item index="myoften">我的常用</el-menu-item> -->

                                    <!-- <el-menu-item index="tools"  class="navi_item"   >全部</el-menu-item>
                                    <el-menu-item index="cals" class="navi_item" >司法计算器</el-menu-item>
                                    <el-menu-item index="search_tools"  class="navi_item">检索</el-menu-item>
                                    <el-menu-item index="filehandle"  class="navi_item">文件处理</el-menu-item>
                                    <el-menu-item index="myoften"  class="navi_item">我的常用</el-menu-item> -->

                                </el-menu-item-group>
                        
                                <!-- <el-submenu index="1-4">
                                    <template slot="title">选项4</template>
                                    <el-menu-item index="1-4-1">选项1</el-menu-item>
                                </el-submenu> -->
                            </el-submenu>

                            <el-submenu index="2">
                                <template slot="title">
                                <i class="el-icon-menu"></i>
                                <span>第三方</span>
                                </template>
                         
                                <el-menu-item-group style="padding-top:0px">
                                    <!-- <template slot="title">分组一</template> -->
                             
                                    <el-menu-item index="company_info"  style="margin-top:-15px" >主体信息</el-menu-item>
                                    <el-menu-item index="ip">知识产权</el-menu-item>
                                    <el-menu-item index="laws"    >法律法规</el-menu-item>
                                    <el-menu-item index="credit">行政处罚和征信</el-menu-item>
                                    <el-menu-item index="justice_open"   >司法公开</el-menu-item>
                                    <el-menu-item index="li_an">网上立案</el-menu-item>
                                </el-menu-item-group>
                        
                                <!-- <el-submenu index="1-4">
                                    <template slot="title">选项4</template>
                                    <el-menu-item index="1-4-1">选项1</el-menu-item>
                                </el-submenu> -->
                            </el-submenu>


                      
                        </el-menu>


                        <!-- <el-menu default-active="1" class="el-menu-vertical-demo" :collapse="isCollapse" @select="handleSelect">
                            <el-menu-item index="tools"  >
                                <i class="el-icon-menu"></i>
                                <span slot="title">官方工具库</span>
                            </el-menu-item>

                            <el-menu-item index="company_info">
                                <i class="el-icon-office-building"></i>
                                <span slot="title">法律工具</span>
                            </el-menu-item> 

                            <el-menu-item index="company_info">
                                <i class="el-icon-office-building"></i>
                                <span slot="title">查询与检索</span>
                            </el-menu-item> 

                            <el-divider content-position="center" style="top:-10px">第三方</el-divider>

                            <el-menu-item index="company_info">
                                <i class="el-icon-office-building"></i>
                                <span slot="title">主体信息</span>
                            </el-menu-item>
        
                            <el-menu-item index="ip"  >
                                <i class="el-icon-reading"></i>
                                <span slot="title">知识产权</span>
                            </el-menu-item>

                            <el-menu-item index="laws">
                                <i class="el-icon-tickets"></i>
                                <span slot="title">法律法规</span>
                            </el-menu-item>

                            <el-menu-item index="credit">
                                <i class="el-icon-search"></i>
                                <span slot="title">行政处罚和征信</span>
                            </el-menu-item>

                            <el-menu-item index="justice_open">
                                <i class="el-icon-view"></i>
                                <span slot="title">司法公开</span>
                            </el-menu-item>

                            <el-menu-item index="li_an">
                                <i class="el-icon-document"></i>
                                <span slot="title">网上立案</span>
                            </el-menu-item>


                        </el-menu> -->


                       
        
                    </div>
 

               </div>
             
      

                 
                <div class="qrcode_box">
                    <div class="mini_box" v-if="!isphone"> 
                        <img src="@/assets/mini.jpg" alt="" style="width:100px;height:100px">
                        <p>微信小程序客户端</p>

                    </div>

                    <!-- <div class="mini_box" v-if="!isphone"> 
                        <img src="@/assets/qrcode_gongzhonghao.jpg" alt="" style="width:100px;height:100px">
                        <p>微信公众号</p>

                    </div> -->

                </div>






            
            </el-col>

           <el-col class="middle1"   :span="14" >
                <el-card    shadow="always"   >
 
                    <div slot="header" class="clearfix">
                        <div>{{card_name}}</div>
                        <!-- <span>{{card_name}}</span> --> 
                        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                        <!-- <el-input  size='medium ' placeholder="搜工具" v-model="search_word"  style="float: right; width:300px"    @keyup.enter.native="SearchTools"></el-input> -->

                        <el-select v-model="choosen_tool" clearable     value-key="detail" filterable placeholder="请选择" @change='choose_tool'  style="float: right; width:300px" >
                            <el-option
                            v-for="item  in allTools"
                            :key="item.subname"
                         
                            :label="item.name"
                            :value="item" 
                           >
                            </el-option>
                          
                        </el-select>

                        <!-- _mark -->


                    </div>

                       <!-- <div class="result_bar"   >
                        <div class="search_line" style=" justify-content: flex-end;" >
                            <el-input placeholder="搜工具" v-model="search_word"  style="width:300px"     @keyup.enter.native="SearchEvent">
                                <el-button slot="append"  type="primary" icon="el-icon-search" @click="SearchEvent" >搜索</el-button>
                            </el-input>  

                        </div>
    
                    </div> -->

                    <!-- <div class="explain_box"  >
                    <div style="width:140px;height:40px;line-height:40px"><span>快速工具导航：</span></div>
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelectType"  style=" height:40px;cursor: pointer;line-height:40px " >
                            <el-menu-item index="tools"  class="navi_item"   >全部</el-menu-item>
                            <el-menu-item index="cals" class="navi_item" >司法计算器</el-menu-item>
                            <el-menu-item index="search_tools"  class="navi_item">检索</el-menu-item>
                            <el-menu-item index="filehandle"  class="navi_item">文件处理</el-menu-item>
                            <el-menu-item index="myoften"  class="navi_item">我的常用</el-menu-item>
                        </el-menu>
                    </div> -->

     
                 
                
                    <!-- <div class="checkListOnShow_bar">
                        <el-checkbox-group v-model="checkListOnShow"  @change="handleCheckList2" :max="8">
                            <el-checkbox v-for="item in ops"   :label="item" :key="item">{{item}}</el-checkbox>
                
                        </el-checkbox-group>

                    </div> -->
            
               
                
                    <div class="list_wrap"  :style="'min-height:'+(screenHeight-80)+'px' ">

            
                      <!-- style="width:100%" -->
                        <div  > 
                             <!-- style="width:100%;display:flex;flex-wrap:wrap;gap:15px" -->
                            <el-row  class="result_box" :gutter="10"  >
                                <!-- :sm="6" -->
                                <el-col      v-for="item in total"  :key="item.name"   style="width:260px; " >
                                    <div class="toolbox"      >
                                      
                                        <div class="p1"> 
                                            <img :src="item.image" alt="">
                                        </div>  

                                        <!-- <a :href="item.detail"  target='_blank' style="text-decoration: none;color:black ;"  >   
                                            <div class="p2" > 
                                                <div class="title"  >{{item.name}}</div>
                                                <div class="subtitle">{{item.subname}}</div>

                                            </div>
                                        </a>  -->

                                      
                                        <a class="p2" :href="item.detail"  target='_blank' style="text-decoration: none;color:black ;"  > 
                                            <div class="title"  >{{item.name}}</div>
                                            <div class="subtitle">{{item.subname}}</div>

                                        </a>
                                    
                                    </div>
                                </el-col>



                            </el-row>

                            <!-- <div class="toolbox"  v-for="item in total"  :key="item.name"    >
                                
                                <div class="p1"> 
                                    <img :src="item.image" alt="">
                                </div> 

                                <a :href="item.detail"  target='_blank' style="text-decoration: none;color:black ;"  >   
                                    <div class="p2"> 
                                        <div class="title">{{item.name}}</div>
                                        <div class="subtitle">{{item.subname}}</div>

                                    </div>
                                </a> 
                            </div> -->
                            
                        


                        </div>
                    

                        <!-- <div class="explain_box"> 第三方工具  </div>

                        <div class="result_box"  > 
                        <div class="toolbox"  v-for="item in tools"  :key="item.name"    >
                            
                                    <div class="p1"> 
                                        <img :src="item.image" alt="">
                                    </div>

                                    <router-link :to="item.detail"  style="   text-decoration: none;color:black ; "  >   
                                    <div class="p2"> 
                                        <div class="title">{{item.name}}</div>
                                        <div class="subtitle">{{item.subname}}</div>

                                    </div>
                                    </router-link> 
                        </div> -->
                        
                  


                    </div>



                </el-card>
             
                       

             
                


            </el-col>

             
            <el-col :span="6" style="min-height:1px;min-width:440px"  class="hidden-md-and-down">
                <el-card    shadow="always"  style="width:95%;height:100%" >
                    <!-- :style="'min-height:'+(screenHeight-60)+'px;width:95%'" -->
                    <!-- ' min-height:'+(screenHeight)+'px  -->

             
                   <!-- <div class="calendar_box" >
                        <el-calendar v-model="calendar_data"> 
                            <template
                                
                                slot="dateCell"
                                slot-scope="{date, data}">

                                <div  @click="changeDate(date,data)"  :class="calendar_dic[data.day.split('-').join('')]? 'calendar_item_remind':''    "> 
                                    {{data.day.split('-').slice(1)[1]}} 
                   
                                </div>
                            </template>



                        </el-calendar>

                   </div>

                   <div  class="cal_notice"  >{{calendar_msg}} </div> -->
           


                    <Calendar_items  > </Calendar_items>
                   
                   
     
                    <!-- :itemList="itemList"  :dateinfo='dateinfo'  -->
  

                

                </el-card>



            </el-col>


                
            <!-- <el-dialog
                title="修改类别：1.法律 2地方法规 3 司法解释 4中外条约 5立法追踪 6政策参考 
7国务院部门规章 8.地方政府规章  9.行政法规 "
                :visible.sync="lawtype_dialogVisible"
                width="30%"
                :before-close="handleClose">
           
                <el-input v-model="lawtype" placeholder="请输入内容"></el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="lawtype_dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="modifyClassHandle">确 定</el-button>
                </span>
            </el-dialog> -->


  


        </el-row>


           
           
           
           
           
           
           
 
           
           
    

       
        <!-- </div> -->
    </div>
     
</template>

<script>

import saveAs from '@/assets/js/html2word/FileSaver.js' 
import JsZip from '@/assets/js/html2word/jszip.min.js' 
import htmlDocx from '@/assets/js/html2word/html-docx.js'

import pako from '@/assets/js/compress/pako.js' 

function getNum() {
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
            'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
            'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
            'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
            'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
            'x', 'y', 'z'];
        var nums = "";
        for (var i = 0; i < 8; i++) {
            var id = parseInt(Math.random() * 61);
            nums += chars[id];
        }
        return nums;
    }

function delCookie () {  //清空所有cookie
    var keys = document.cookie.match(/[^ =;]+(?==)/g)
    if (keys) {
        for (var i = keys.length; i--;) {
        document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
        document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
        document.cookie = keys[i] + '=0;path=/;domain=ratingdog.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
        }
    }
}

import Pages from '@/components/Pages.vue'

import Calendar from  '@/components/calendar/calendar.vue'
import Calendar_items from  '@/components/calendar/calendar_items.vue'
 
// import Calendar from './calendar/calendar.vue'

// import { delete } from 'vue/types/umd'
// import Pages from '../Pages.vue' 

 
function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true 
	} else {
		return false
	}
}   

 

var image_preurl ="https://11law.lawtip.cn"


export default {
        name: 'lawtip',
        components: {
            Pages,Calendar,Calendar_items
                
        },
		// props: {
		// 	pageId: String
        // },
        // metaInfo: {
        //     title: '', // set a title
        //     meta: [{                 // set meta
        //         name: 'keywords',
        //         content: '合同模板,律师工具,找律师'
        //     }],
      
        // },
        data() {
			return { 
                dialogVisible:false,
                title_dialogVisible:false,
                lawtype_dialogVisible:false,

                // dateinfo:{},
                // calendar_msg:'数据与律师云助理小程序同步',
                // calendar_dic:{},

                itemList: [
                    // {
                    //     addDate: "2023-3-1",
                    //     content: "",
                    //     date: "22",
                    //     end_time: "尚未设置",
                    //     isnotice: "yes",
                    //     latitude: "",
                    //     level: "1",
                    //     location: "添加地点",
                    //     longitude: "",
                    //     month: "3",
                    //     openid: "o2cfM4rDLXSGkR2wKOi9XNkpgbyw",
                    //     register_phone: null,
                    //     sharefrom: "",
                    //     sharefrom_avatar: "",
                    //     start_time: "3-22 14:30",
                    //     timestamp: 1679466600,
                    //     title: "苏理与山西迈润田开庭，十一法庭开庭",
                    //     userid: null,
                    //     year: "2023",
                    //     _id: "85956248-edba-40aa-817b-bd8ffde0e065",
                    // }
                ] ,
                card_name:'全部',
                
                isCollapse:false,
                getStarSig:0,
                isphone:false,
               selects:[],     
               activeIndex:'all',  
               
               inputValue:'',
               lawtype:'',
               screenWidth:window.innerWidth,
               screenHeight:window.innerHeight,

                search_word:'',

                total:[],
                opends: ['1'],
                // calendar_data:new Date(),
                choosen_tool:'',
                allTools:[], //所有的工具都在这里，数组形式
                sum:{   
                    tools:{
                        legalfee:{ name:'诉讼费计算' ,image: image_preurl+"/images/toolspic/t33.png ",   subname:'好用的诉讼费计算器' ,detail:'legalfee' }, 
                        lawyerfee:{ name :"律师费计算",  image:  image_preurl+"/images/toolspic/1113503.gif  ",  detail:'lawyerfee'  },
                        interest3:{ name :"LPR利息计算器",   subname:'新基准利率，19年8月20后基准利率' , image:  image_preurl+"/images/toolspic/t22.png  ", detail:'lpr'  },
                        interest:{ name :"旧基准利息计算器",    subname:'19年8月20前基准利率', image: image_preurl+"/images/toolspic/t22.png  "   ,detail:'interest'  },
                        dayscal:{ name :"天数计算器",  image: image_preurl+"/images/toolspic/t27.png  ",detail:'daycal' },
                        suitinsurance:{ name :"诉讼保全险计算器",  image:  image_preurl+"/images/toolspic/t34.png ", detail:'subao' },
                        traffic:{ name :"交通/人损赔偿计算器",  image: image_preurl+"/images/toolspic/t35.png  ",  detail:'traffic'  },
                        workinjury:{ name :"工伤赔偿计算器",  image:  image_preurl+"/images/toolspic/t36.png  ",  detail:'workinjury' },
                        enforce:{ name :"执行期利息计算器",  image:  image_preurl+"/images/toolspic/zhixingcal.png  ",  detail:'enforce' },
                        interest2:{ name :"自定义利息计算器",  image: image_preurl+"/images/toolspic/t22.png  ",   detail:'interest2' },
                        
                        numtrans:{ name :"数字转大写",  image: image_preurl+ "/images/toolspic/logo_one.png",detail:'numtrans' },

                        int4:{ name :"高级合同违约金计算器",  image:  image_preurl+"/images/toolspic/calculate67.png ", detail:'int4' },
                        int5:{ name :"民间借贷计算器",  image:  image_preurl+"/images/toolspic/loan.png ", detail:'int5'  },  //mark

                        // creditloss_all:{ name :"被执行人查询(综合查询)",  image:  image_preurl+"/images/toolspic/laolai.png ",   path:"/pages/tools/creditloss_all/creditloss_all" },
                        announce:{ name :"公告查询",  image:  image_preurl+"/images/toolspic/gonggao.png " , detail:'announce'  },
                        // JudgeList:{ name :"法官名录查询",  image:   image_preurl + "/images/toolspic/minglu.png ",   path:"/pages/tools/JudgeList/JudgeList" },
                        trialNotice:{ name :"开庭公告查询",image: image_preurl + "/images/toolspic/yhammer.png ", detail:'trialNotice' },
                        wenshu:{ name :"裁判文书大数据",  image:   image_preurl + "/images/toolspic/t38.png ", detail:'wenshu'  },
                        lawlib2:{ name :"法律法规数据库检索",  image:    image_preurl+"/images/toolspic/searchbook.png ", detail:'lawlib' },
                        lawlib_causedetail:{ name :"案由检索解析",image: image_preurl + "/images/toolspic/t331.png ", detail:'lawlib_causedetail' },
                        // crim_anyl:{ name :"刑事罪名检索解析",  image:  image_preurl + "/images/toolspic/criminal_pic.png " , detail:'crim_anyl' },
                        crim_sand:{ name :"刑事量刑大数据",  image: image_preurl+"/images/toolspic/criminal_pic.png ", detail:'crim_sand' },

                        sound2txt:{ name :"录音转文本",  image:  image_preurl+"/images/toolspic/sound.png", detail:'sound2txt'   },
                        pdf:{ name :"pdf文件处理",  image:  image_preurl+"/images/toolspic/PDF2.png", detail:'pdf'   },
                        saomiao:{ name :"扫描助手",  image:  image_preurl+"/images/toolspic/camera.png", detail:'saomiao'   }, 
                        ai_txt:{ name :"AI文本查错（暂停服务）",  image:  image_preurl+"/images/toolspic/txt.png", detail:'txtcheck'   },
                        pic2txt:{ name :"OCR文字识别",  image:  image_preurl+"/images/toolspic/transfer.png", detail:'pic2txt'   },
                    },

                    cals:[
                        { name:'诉讼费计算' ,image: image_preurl+"/images/toolspic/t33.png ",   subname:'好用的诉讼费计算器' ,detail:'legalfee' },
                        { name :"律师费计算",  image:  image_preurl+"/images/toolspic/1113503.gif  ",  detail:'lawyerfee'  },
                        
                        { name :"LPR利息计算器",  subname:'新基准利率计算器，19年8月20后基准利率' ,  image:  image_preurl+"/images/toolspic/t22.png  ", detail:'lpr'  },
                        { name :"旧基准利率计算器",  subname:'19年8月20前基准利率' , image: image_preurl+"/images/toolspic/t22.png  "   ,detail:'interest'  },
                  
                        { name :"诉讼保全险计算器",  image:  image_preurl+"/images/toolspic/t34.png ", detail:'subao' },
                        { name :"交通/人损赔偿计算器",  image: image_preurl+"/images/toolspic/t35.png  ",  detail:'traffic'  },
                        { name :"工伤赔偿计算器",  image:  image_preurl+"/images/toolspic/t36.png  ",  detail:'workinjury' },
                        { name :"执行期利息计算器",  image:  image_preurl+"/images/toolspic/zhixingcal.png  ",  detail:'enforce' },
                        { name :"自定义利息计算器",  image: image_preurl+"/images/toolspic/t22.png  ",   detail:'interest2' },
                        
               
                        { name :"高级合同违约金计算器",  image:  image_preurl+"/images/toolspic/calculate67.png ", detail:'int4' },
                        { name :"民间借贷计算器",  image:  image_preurl+"/images/toolspic/loan.png ", detail:'int5'  },  //mark

                        { name :"数字转大写",  image: image_preurl+ "/images/toolspic/logo_one.png",detail:'numtrans' },
                        { name :"天数计算器",  image: image_preurl+"/images/toolspic/t27.png  ",detail:'daycal' },

                    ],
                    search_tools:[
                        { name :"裁判文书大数据",  image:   image_preurl + "/images/toolspic/t38.png ", detail:'wenshu'  },
                        
                        { name :"公告查询",  image:  image_preurl+"/images/toolspic/gonggao.png " , detail:'announce'  },
                        // JudgeList:{ name :"法官名录查询",  image:   image_preurl + "/images/toolspic/minglu.png ",   path:"/pages/tools/JudgeList/JudgeList" },
                        { name :"开庭公告查询",image: image_preurl + "/images/toolspic/yhammer.png ", detail:'trialNotice' },
                
                        { name :"法律法规数据库检索",  image:    image_preurl+"/images/toolspic/searchbook.png ", detail:'lawlib' },
                        { name :"案由检索解析",image: image_preurl + "/images/toolspic/t331.png ", detail:'lawlib_causedetail' },
                        // crim_anyl:{ name :"刑事罪名检索解析",  image:  image_preurl + "/images/toolspic/criminal_pic.png " , detail:'crim_anyl' },
                        { name :"刑事量刑大数据",  image: image_preurl+"/images/toolspic/criminal_pic.png ", detail:'crim_sand' },

                    ],

                    filehandle:[
                        { name :"录音转文本",  image:  image_preurl+"/images/toolspic/sound.png", detail:'sound2txt'   },
                        { name :"pdf文件处理",  image:  image_preurl+"/images/toolspic/PDF2.png", detail:'pdf'   },
                        { name :"AI文本查错（暂停服务）",  image:  image_preurl+"/images/toolspic/txt.png", detail:'txtcheck'   },
                        { name :"OCR文字识别",  image:  image_preurl+"/images/toolspic/transfer.png", detail:'pic2txt'   },
                        { name :"扫描助手",  image:  image_preurl+"/images/toolspic/camera.png", detail:'saomiao'   },
                    ],


                    company_info:[
                        {name :"国家企业信用信息公示系统", subname:'企业信息公示官方网站' ,  image:  image_preurl+"/images/toolspic/IE-circle-fill.png", detail:'https://www.gsxt.gov.cn/index.html' ,attr:'other',target:'_blank' },
                        {name :"天眼查",   image:  "https://cdn.tianyancha.com/wap/images/18blue/weixinlogo.png", detail:'https://www.tianyancha.com/' ,attr:'other',target:'_blank' },
                        {name :"企查查",   image:  "https://qcc-static.qcc.com/resources/web/omaterial/favicon.png", detail:'https://www.qcc.com/' ,attr:'other',target:'_blank' },
                        {name :"启信宝",   image:  "https://www.qixin.com/favicon.ico", detail:'https://www.qixin.com/' ,attr:'other',target:'_blank' },
                   
                        {name :"商务部业务系统统一平台",  subname:'外商投资企业查询官方网站' ,    image: image_preurl+"/images/toolspic/IE-circle-fill.png", detail:'https://wzxxbg.mofcom.gov.cn/gspt/' ,attr:'other',target:'_blank' },
                        {name :"台湾工商登记资料查询服务",  subname:'台湾省企业工商信息查询官方网站' ,    image:  "https://findbiz.nat.gov.tw/fts/favicon.ico", detail:'https://findbiz.nat.gov.tw/fts/query/QueryBar/queryInit.do' ,attr:'other',target:'_blank' },
                   
                   ],

                    // online_case_regis:[
                    //     {name :"江苏法院诉讼服务网", subname:'江苏法院网上立案' ,  image:  image_preurl+"/images/toolspic/IE-circle-fill.png", detail:'https://ssfw.jsfy.gov.cn/' ,attr:'other',target:'_blank' },
                    //     {name :"天眼查",   image:  "https://cdn.tianyancha.com/wap/images/18blue/weixinlogo.png", detail:'https://www.tianyancha.com/' ,attr:'other',target:'_blank' },
                    //     {name :"企查查",   image:  "https://qcc-static.qcc.com/resources/web/omaterial/favicon.png", detail:'https://www.qcc.com/' ,attr:'other',target:'_blank' },
                    //     {name :"启信宝",   image:  "https://www.qixin.com/favicon.ico", detail:'https://www.qixin.com/' ,attr:'other',target:'_blank' },
                   

                    // ],

                    ip:[
                        {name :"商标局商标查询", subname:'国知局商标查询官网' ,  image: "https://tysf.cponline.cnipa.gov.cn/am/img/logo%20-%20header.da3410d0.png", detail:'http://wcjs.sbj.cnipa.gov.cn/' ,attr:'other',target:'_blank' },
                       
                        {name :"地理标志产品检索",   image:  "https://tysf.cponline.cnipa.gov.cn/am/img/logo%20-%20header.da3410d0.png", detail:'https://dlbzsl.hizhuanli.cn:8888/Product/Search' ,attr:'other',target:'_blank' },
                        {name :"商标分类查询",     image:  "http://www.sbfl.cn/favicon.ico", detail:'http://www.sbfl.cn/' ,attr:'other',target:'_blank' },
                      
                        {name :"ICP/IP地址/域名信息备案管理系",     image:  "https://beian.miit.gov.cn/img/bg_logo.2ce2f33d.png", detail:'https://beian.miit.gov.cn/#/Integrated/index' ,attr:'other',target:'_blank' },
                      

                        {name :"专利和集成电路布图设计业务办理统一身份认证平台",     image:  "https://tysf.cponline.cnipa.gov.cn/am/img/logo%20-%20header.da3410d0.png", detail:'https://tysf.cponline.cnipa.gov.cn/am' ,attr:'other',target:'_blank' },
                       
// https://beian.miit.gov.cn/#/Integrated/index

                    ],

                    credit:[
                        {name :"中国执行信息公开网", subname:'被执行人、失信人查询官网' ,  image: image_preurl+"/images/toolspic/IE-circle-fill.png", detail:'http://zxgk.court.gov.cn/' ,attr:'other',target:'_blank' },
                       
                        {name :"行政处罚文书网", subname:'行政处罚网官网' ,  image: image_preurl+"/images/toolspic/IE-circle-fill.png",  detail:'https://cfws.samr.gov.cn/' ,attr:'other',target:'_blank' },
                        
                        // {name :"商标分类查询",     image:  "http://www.sbfl.cn/favicon.ico", detail:'http://www.sbfl.cn/' ,attr:'other',target:'_blank' },
                        {name :"破产债务人信息查询",     image:  "https://pccz.court.gov.cn/pcajxxw/resources/image/index/logo.png", detail:'https://pccz.court.gov.cn/pcajxxw/pctzr/tzrdh?lx=1' ,attr:'other',target:'_blank' },
                       
                        {name :"上海票据交易所",   subname:'票据信息披露平台',  image:  "https://disclosure.shcpe.com.cn/static/favicon.ico", detail:'https://disclosure.shcpe.com.cn/#/dashboard' ,attr:'other',target:'_blank' },
                      


                    ],

                    justice_open:[
                        {name :"裁判文书网", subname:'裁判文书公开、查询的官方权威网站' ,  image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png",  detail:'https://wenshu.court.gov.cn/' ,attr:'other',target:'_blank' },
                       
                        {name :"审判流程公开网", subname:'支持当事人、代理人查询案件进程' ,  image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png",  detail:'https://splcgk.court.gov.cn/lcgkw/user#' ,attr:'other',target:'_blank' },
                       
                        {name :"开庭公告查询",  subname:'审判流程公开网开庭公告查询' ,  image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png",  detail:'https://splcgk.court.gov.cn/gzfwww//ktgg' ,attr:'other',target:'_blank' },
                       
                        {name :"人民法院公告网",  subname:'主要是有送达问题综合性公开' ,   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png",  detail:'https://rmfygg.court.gov.cn/web/rmfyportal/noticeinfo' ,attr:'other',target:'_blank' },
                       

                    ],

                    li_an:[
                        {name :"人民法院律师服务平台",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png",  detail:'https://lspt.court.gov.cn/' ,attr:'other',target:'_blank' },
                       
                        {name :"上海法院诉讼服务网",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png",  detail:'https://www.hshfy.sh.cn/shwfy/ssfww/' ,attr:'other',target:'_blank' },
                       
    
                        {name :"北京法院诉讼服务",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png",  detail:'https://www.beijinglawyers.org.cn/lxqtmodel/model_zh/ssfw/ssfw.html' ,attr:'other',target:'_blank' },
                       



                    ],



                    laws:[

                        {name :"国家法律法规数据库",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'https://flk.npc.gov.cn/' ,attr:'other',target:'_blank' },
                        {name :"司法部行政法规库",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://xzfg.moj.gov.cn/search2.html' ,attr:'other',target:'_blank' },
                       
                       
                       {name :"公安部规章库",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'https://app.mps.gov.cn/gdnps/zc/list.jsp' ,attr:'other',target:'_blank' },
                        {name :"商务部规章库",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://www.mofcom.gov.cn/zfxxgk/xxgkRuleList.shtml' ,attr:'other',target:'_blank' },
                       
                        {name :"工业和信息化规章库",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'https://www.miit.gov.cn/search/gzk.html' ,attr:'other',target:'_blank' },
  
                        {name :"教育部规范性文件",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://www.moe.gov.cn/was5/web/search?channelid=267907' ,attr:'other',target:'_blank' },
                       
                        {name :"卫健委规章库",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://www.nhc.gov.cn/wjw/c100022/fg_gzk.shtml' ,attr:'other',target:'_blank' },
                       
                        {name :"发改委规范文件库查询",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'https://www.ndrc.gov.cn/xxgk/wjk/index.html?tab=gfxwj&code=&state=123' ,attr:'other',target:'_blank' },
                       
                        {name :"人力资源和社会保障部",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://www.mohrss.gov.cn/xxgk2020/zcwjk/' ,attr:'other',target:'_blank' },
                       
                        {name :"财政部政策发布",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://www.mof.gov.cn/zhengwuxinxi/zhengcefabu/' ,attr:'other',target:'_blank' },
                       
                        {name :"民政部规章库",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'https://xxgk.mca.gov.cn:8445/gdnps/pc/gzk/index.jsp' ,attr:'other',target:'_blank' },
                        {name :"自然资源部",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://f.mnr.gov.cn/' ,attr:'other',target:'_blank' },
                        {name :"交通运输部规章",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'https://xxgk.mot.gov.cn/2020/jigou/' ,attr:'other',target:'_blank' },
                        {name :"农业农村部",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://www.moa.gov.cn/gk/zcfg/' ,attr:'other',target:'_blank' },
                       
                        {name :"国家市场监督管理总局",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'https://gkml.samr.gov.cn/' ,attr:'other',target:'_blank' },
                       
                        {name :"中国人民银行",   image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://www.pbc.gov.cn/tiaofasi/144941/144957/index.html' ,attr:'other',target:'_blank' },
                        {name :"海关总署",    image: "https://app.mps.gov.cn/gdnps/zc/images/gh.png", detail:'http://www.customs.gov.cn/customs/302249/302266/index.html' ,attr:'other',target:'_blank' },
                       
                    ],

                    // https://cdn.tianyancha.com/wap/images/18blue/weixinlogo.png

                },


              

             
              
            }
        },
        beforeRouteEnter(to, from, next) {
     


            if (from.name == 'article_detail') { // 这个name是下一级页面的路由name
                to.meta.isBack = true; // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
            }
            next()
        },

        created(){
     

            this.userInfo=this.$root.userInfo

            // let date=new Date()
            // let y=date.getFullYear();      // 获取当前年份
            // let m=date.getMonth() + 1;    //返回的月份少一个月 需要+1
            // let d=date.getDate();  

            // let beforeDayCount = 0,
            // beforeYear, //上页月年份 
            // beforMonth, //上页月份
            // afterYear, //下页年份
            // afterMonth; //下页月份
    

            // //上一个月月份
            // beforMonth = m === 1 ? 12 : m - 1;
            // //上一个月年份
            // beforeYear = m === 1 ? y - 1 : y;
            // //下个月月份
            // afterMonth = m === 12 ? 1 : m + 1;
            // //下个月年份
            // afterYear = m === 12 ? y + 1 : y;



            // let dateinfo={
            //     after_month: afterMonth,
            //     after_year: afterYear,
            //     before_month: beforMonth,
            //     before_year: beforeYear,
            //     month: m,
            //     year: y,
            // }

            // this.dateinfo=dateinfo
            // this.setDateInfo(new Date())
            // console.log('this.dateinfo:',this.dateinfo)
            // this.GetThisMonCal(this.dateinfo)



            

             

 
             

        },

        mounted() {
            // this.SearchEvent_new(1,0,1) _mark
            this.total=this.sum.tools 

                   
            let p=this.sum.cals.concat(this.sum.search_tools,this.sum.filehandle,this.sum.company_info,this.sum.ip,this.sum.credit,this.sum.justice_open,this.sum.li_an,this.sum.laws );
            
            
            // console.log('p:',p)
          
            this.allTools=p
     



        },
        // activated() {
   
        // },
        methods:{
         
            BackToHome(){ this.$router.push({name:'home'})},
            
            choose_tool(){ //_mark
                console.log(this.choosen_tool)
                // this.total=this.sum.tools 
                if(!this.choosen_tool){
                    this.total=this.sum.tools 
                }else{
                    this.total=[this.choosen_tool]
                }

            },

            tableCellStyle({row,rowIndex}){
                return  {'max-height':'150px' };
            },

            DownLoadPicked(num=1){
                var target=[],data
                if(num==1){
                    for (let item of this.multipleSelection){
                        target.push(item.docid)
                    }
                }else{
                    for (let item of this.multipleSelection2){
                        target.push(item.docid)
                    }
                }
             
                if(target.length==0){
                     this.$message({
                        message: '未选中任何文书',
                        type: 'warning'
                    });
                    return
                }else{
                        var zip =new JsZip()
                        let timestamp=new Date().getTime();
                        var folder = zip.folder("律师云助理裁判文书");
                        var len=target.length
                        var num=0
                        for (let i of target){
                            data= { 
                                docid:i,
                                whattodo: "wenshu_getDetail"
                            }
                            this.axios.post(this.$root.rootUrl+'mini_app'   ,data
                            ).then(function (res) {
                                window.console.log(res)
                               
                                if(res.status==200 ){
                                    window.console.log(res.data.data);
                                    var result=res.data
                                    if(result.status=='badgate'){
                                        // that.$message({
                                        //     message: '请先登录哦',
                                        //     type: 'warning'
                                        // });
                                        that.$message('请先登录哦');
                                    }else  if(result.status=='ok'){
                                        let data=result.data
                                        var converted = htmlDocx.asBlob(data._source.html); //,{orientation:'landscape'}
                                        folder.file(data._source.name+'.docx', converted);
                                        num++

                                    }
                                

                                }
                                if(num==len){
                                    zip.generateAsync({type:"blob"}) //{type:"blob"}
                                    .then(function(content) {
                                        window.console.log('generateAsync then')
                                        saveAs(content, "律师云助理裁判文书"+timestamp+".zip");
                                    });
                                }
                
                                
                            }).catch(function (error) {
                                window.console.log(error);
                               
                            });

                        }

                       



                }



            },

            search_result(){
            //    this.params.mode=''
            //    this.dialogVisible = false
               if(this.$store.state.accountInfo.vip==1){
                   this.SearchEvent_new(1,0,1)
               }else if(this.params.cause){
                    this.$notify({
                        title: '提示',
                        message: '该功能为会员功能哦',
                        type: 'info',
                        duration: 4000
                    });
                  
               }
                

            },

          
            SearchTools(){


            },
 
            

           

        

            handleCheckList(value){
                // console.log('handleCheckList value:',value)
                this.param.tag=value
                this.param.page=1
                this.getList()
            },
            handleCheckList2(value){
                // console.log('handleCheckList value:',value)
              

                this.checkListOnShow=value

                //   choices:[{label:"案件类型",'value':'caseType'},{label:"文书类型",'value':'wenshuType'},{label:"审判程序",'value':'stage'},
                //         {label:"法院层级",'value':'courtLevel'},{label:"裁判日期",'value':'trialDate'} ],

                let arr=[]
                // let dic=this.choices2
                // console.log('dic:',dic)
                for (let i of this.checkListOnShow){
        
                    arr.push({ label:i,'value': this.choices2[i]    })
                }
                console.log('arr:',arr)
                this.choices=arr
                // this.param.tag=value
                // this.param.page=1
                // this.getList()
            },
  
 



            choose_info(id){
                // console.log("---e:",e)

                // var index=e.srcElement.dataset.index
                // var mode=e.srcElement.dataset.mode
                // console.log("---index:",index)
                 
                var element = document.getElementById(id);
                console.log("element:",element)
                var index=element.dataset.index
                var mode=element.dataset.mode
                
                console.log("---index:",index) 
                console.log("---mode:",mode)

                let obj=this.resultList[index]
                console.log('-------------obj:',obj)

                obj.info=mode
                // this.resultList[index]=obj
                if(mode=='5'){
                    let legalbasis=this.resultList[index]._source.legalbasis
                    let isLegalHandled=this.resultList[index]._source.isLegalHandled || ''
                    let legal='';
                    if(legalbasis && !isLegalHandled){
                        for(let p of legalbasis){
                            console.log("p:",p)
                            let lawname='《'+p.lawname+'》'
                            let article=p.article?p.article:''
                            let para=p.para?p.para:''
                            let subpara=p.subpara?p.subpara:''
                            legal=legal+lawname+article+para+subpara+'\n'

                            // legal=legal+'《'+p.lawname+'》'//+p.article?p.article:''+p.para? p.para:''+p.subpara? p.subpara:''+'\n'
                            // legal=legal+p.article?p.article:''
                            // legal=legal+p.para? p.para:''
                            // legal=legal+p.subpara? p.subpara:''+'\n'
                            console.log("1 legal:",legal)
                        }
                        obj._source.legalbasis=legal
                        obj._source.isLegalHandled=1
                        // this.$set(this.resultList, index, obj);
                    }else if(!legalbasis && !isLegalHandled){
                        obj._source.legalbasis=legal

                    }
                }

                this.$set(this.resultList, index, obj);


                // }else{
                //     this.$set(this.resultList, index, obj);
                // }


                // this.$set(this.resultList, index, obj);
                // this.$set(this.resultList[index], 'info', mode);

                // this.resultList[index].info=mode

                // console.log("this.resultList:",this.resultList)

            },
          
           


         
            // handleSort(command) {
            //     window.console.log(command)
                
            //     if(command!=this.param.sortItem.value && command=='recent_update'){
            //         this.param.sortItem.name='最近更新'
            //         this.param.sortItem.value='recent_update'
            //         this.param.page=1
            //         window.console.log(1,this.param.sortItem)
            //         this.getList(1)

            //     }else if(command!=this.param.sortItem.value && command=='most_stars'){
            //         this.param.sortItem.name='最多喜欢'
            //         this.param.sortItem.value='most_stars'
            //         this.param.page=1
            //         this.getList(1)
            //     }else if(command!=this.param.sortItem.value && command=='fewest_stars'){
            //         this.param.sortItem.name='最少喜欢'
            //         this.param.sortItem.value='fewest_stars'
            //         this.param.page=1
            //         this.getList(1)
            //     }else if(command!=this.param.sortItem.value && command=='least_recent_update'){
            //         this.param.sortItem.name='最近最少更新'
            //         this.param.sortItem.value='least_recent_update'
            //         this.param.page=1
            //         this.getList(1)
            //     } 


              

            

            // },

 


            handleSelect(key, keyPath) {
               window.console.log( key);
               window.console.log( keyPath);
               this.total=this.sum[key]
               let name={'cals':'司法计算器','search_tools':"查询与检索",'filehandle':'文件处理','myoften':'我的常用','all':'全部'}
               this.card_name=name[key]

                //    this.type=key
                //    window.console.log('this.type:',this.type);
                //    this.$emit('ChangeFunctionBox',key); 
            },


            handleSelectType(key, keyPath) {
                console.log(key, keyPath);
                if(key!='myoften'){
                    this.total=this.sum[key]
                }else{
                    let oftenuse=localStorage.getItem('oftenuse') || '{}'

                    try {
                        oftenuse=JSON.parse(oftenuse)
                    } catch (error) {
                        oftenuse={}
                    }

                    

                    console.log('oftenuse:',oftenuse)

                    let often_arr=[]
                    // let oftenuse=wx.getStorageSync('oftenuse') || {}
               
                    for (let key in oftenuse){
                        if (key && key != 'undefined')  {
                            often_arr.push({ tag: key ,num:oftenuse[key] })
                        }

                    }

                    often_arr.sort(function(a,b){
                        return b.num - a.num
                    })

  
                    
                    console.log('often_arr 0:',often_arr)

                    if (often_arr.length>8){
                        often_arr=often_arr.slice(0,8)
                    }

                //    console.log('often_arr1 :',often_arr)

                    // let number= 8-often_arr.length
                    // var _result
                    // while (number>0){
                    //     for (let k in  this.sum.tools){
                    //         console.log('k :',k)
                    //         // number--
                   
                    //         _result=often_arr.findIndex( item=>item.tag === k )
                    //         if (_result==-1){
                    //             often_arr.push(  { tag: k  }  )
                    //             number--
                    //         }
                    //         if (number==0){
                    //             break
                    //         }

                    //     }

                    // }
                    
                    console.log('often_arr:',often_arr)
                    let arr=[] 
                    for(let p of often_arr){
                        if(this.sum.tools[p.tag]){
                            arr.push(this.sum.tools[p.tag])
                        }
                      
                        this.total=arr


                    }
                    console.log('arr:',arr)



                }
            
                 
                // lawtype
            },


 
 
 

            BackToOri(){
 


                this.param={"search_input":"" ,"page":1 ,  "sortItem":{"name":"最近更新","value":"recent_update" }}
                // this.param.search_input=''
                this.getList()

            },
 
 

   
 


        
          


        
            MouseOnHandle(_id,index){
                // window.console.log('mouse on index:',index)
                //           width:240px;
                // height: 360px;
                document.getElementById(_id).style.width='264px'
                document.getElementById(_id).style.height='396px'

                document.getElementById(_id).style.margin='2px 13px'


                document.getElementById(_id+'title').style.color='red'
                // document.getElementById(_id).style.bgColor='rgba(0, 0, 0, .3)'
                 
            },
            MouseOutHandle(_id,index){
                // window.console.log('mouse out index:',index)
                document.getElementById(_id).style.width='240px'
                document.getElementById(_id).style.height='360px'

                document.getElementById(_id).style.margin='20px 25px '

                document.getElementById(_id+'title').style.color='black'

            },

            errorHandler() {
                return true
            },
            SignIn(){
                window.console.log('SignIn')
                // this.SignInVisibl=true 
                let num= getNum()
                window.console.log('num:',num)
                var nowurl = window.location.href;
                let target=window.btoa(nowurl)
                let state=num+'(redirect)'+target
                let url='https://open.weixin.qq.com/connect/qrconnect?appid=wxe00435b975483ad0&redirect_uri=http%3a%2f%2fwww.lawtip.cn%2f%23%2flogin&response_type=code&scope=snsapi_login&state='+state+'#wechat_redirect'
                
                sessionStorage.setItem("loginStatus", num);
                window.open(url,"_self")


                // window.open('http://www.lawtip.cn/wenshuDetail.html?'+timestamp, '_blank')

            },

            SignOut(){
                var that=this
                window.console.log('SignOut')
                delCookie()
                this.$root.islogin=false
                this.islogin=false
                // that.$store.commit('getUserInfo',{} )
                // that.$store.commit('ChangeLoginStatus',false)
                // this.$notify({
                //     title: '成功',
                //     message: '成功退出登录',
                //     type: 'success'
                // });
                // localStorage.setItem("isLogin", 0);
                sessionStorage.removeItem("isLogin");
                sessionStorage.removeItem("userInfo");
                sessionStorage.removeItem("accountInfo");

                this.axios.get('../PHPserver/login/SignOut.php',{
                // params: {
                //     timestamp:timestamp
                // }
                }).then(function (res) { 
                    if(res.status==200){
                        window.console.log(res.data)
                        let result=res.data
                        if(result.status=='ok'){
                            // that.$root.userInfo=result.userInfo;
                            // that.$root.accountInfo=result.accountInfo;
                            that.$root.islogin=false;				
                            that.islogin=false
                            that.userInfo.avatarUrl='@/assets/images/touxiang.png'
                            // window.open('/',"_self")
                            window.open(window.location.href,"_self")


                            
                        }        


                    }

                }).catch(function (error) {
                    window.console.log(error);
                });






                

            },
            pickOneRow(selection, row){
                console.log('row:',row)
                console.log('selection:',selection)

            },

            handleSelectionChange(val) {
                console.log('val:',val)
                this.multipleSelection = val;
                // console.log("this.$refs.multipleTable.toggleRowSelection(row):",this.$refs.multipleTable.toggleRowSelection(row,selected))

                // let i,p
                // let sig
                // let arr=[]
                // for(i=0;i<val.length;i++){
                //     sig=0
                //    for(p=0;p<this,selects.length;p++){
                //        if(this.selects[p].docid==val[i]){
                //            sig=1
                //            break
                //        }
                //    }
                //    if (sig==0){
                //        arr.push(val[p])
                //    }
                // }
                // if(arr.length>0){
                //     this.selects=this.selects.concat(arr)
                // }

            },

            handleSelectionChange2(val) {
                console.log('val:',val)
                this.multipleSelection2 = val;
 

            },

            handleDeleteCase(scope){
                let ind=scope.$index
                let row=scope.row
                this.$delete(this.similarCase,[row.docid]);
                this.$delete(this.mycases, ind );
                localStorage.setItem('similarCase', JSON.stringify(this.similarCase));

            },

        

         
      

            ManageArticleHandle(command){
                var para=command.split(',')
                window.console.log(para)
                if (para[0]=='modify'){
                    let routeData = this.$router.resolve({name:'my_draft', params: {id: para[1]} });
                    window.open(routeData.href, '_blank')
                    // this.$router.push({name:'my_draft',params: {id:para[1]}})
                }
                else if(para[0]=='delete'){
                
                    this.ConfirmDelete(para[1]) 

                } else  if (para[0]=='modifyTitle'){
                    this.title_dialogVisible=true
                    let _id=para[1]
                    let ind=para[2]
                    this.titleInput=this.resultList[ind]._source.name
                    this.lawtype=this.resultList[ind]._source.effectLevel
                    this.levelInput=this.resultList[ind]._source.level


                    this.modify_ind=parseInt(ind)
                    this.modify_id=_id
                    // let routeData = this.$router.resolve({name:'my_draft', params: {id: para[1]} });
                    // window.open(routeData.href, '_blank')
                    // this.$router.push({name:'my_draft',params: {id:para[1]}})
                }else  if (para[0]=='modifyClass'){
                    this.lawtype_dialogVisible=true
                    let _id=para[1]
                    let ind=para[2]
                    this.lawtype=this.resultList[ind]._source.effectLevel
                    console.log("this.effectLevel:",this.effectLevel)
                    this.modify_ind=parseInt(ind)
                    this.modify_id=_id
                   
                }

                else  if (para[0]=='invisible'){
                
                    let _id=para[1]
                    let ind=para[2]
              
                    this.modify_ind=parseInt(ind)
                    this.modify_id=_id

                    this.modifyOnshow(_id)

                   
                }
                 
                 

            },


   

          

            ShowOptions(){
                window.console.log("ShowOptions occur")
            },


            timestampToTime(timestamp) {
     
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + '';
                // var h = date.getHours() + ':';   //
                // var m = date.getMinutes() + ':';//
                // var s = date.getSeconds();//
                if (M.length==1){
                    M='0' +M
                }
                if (D.length==1){
                    D='0' +D
                }
           
                return Y + M + D ;  //+ h + m + s

            },

            get_report(){
                var that=this
                var datas= { 
                    whattodo:'get_report',
                    // data:JSON.parse(localStorage.getItem('similarCase')) || this.similarCase
                }
                this.axios.post(this.$root.rootUrl+ 'mini_app',datas
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='ok'){
                            that.similarCase=result.data
                            let d=JSON.stringify(that.similarCase)
                            that.lastsave=d
                            localStorage.setItem('similarCase', d);
                        }
                        
                

                     
                    }


                    
                }).catch(function (error) {
                    window.console.log(error);

                });
            },

            close_case_handle(){
                console.log('close_case_handle')
                if(this.$store.state.accountInfo.vip==1 ){  // && Object.keys(this.similarCase).length
                    this.save2server()
                }
            },

          

         
      
    

            // handleNodeClick1(data){
            //     console.log(data);
            //     if(!data.children){
            //         this.searchCause(data.value)
            //     }

            // },
            handleNodeClick(data) {
                // console.log(data);
                let type
                if(data.children){
                    type=data.type
                }


                if(!data.children){
                    // console.log('data.range:',data.range);
                    if(['year','stage','wenshu_type','caseType','cause','court','court_level'].indexOf(data.range)!=-1  ){
                        // console.log('!data.children');
                        this.AddParam(data.range,data.value)
                    }
                }
            },

            AddParam(key,value){
                this.params[key]=value
                this.SearchEvent_new(1,0,1)

            },


            handleNodeClick2(id) {

               if( this.param.wenshu_type.indexOf(id)==-1){
                   this.param.wenshu_type.push(id)
               }
                
            },
            handlePriceNode(mode){
                if( this.param.price.indexOf(mode)==-1){
                   this.param.price.push(mode)
                }
                
            },

            deleteType(index){
                this.param.wenshu_type.splice(index,1)
            },

            deleteKeword(index){
                if(this.params.keywords.length==1){
                    this.params.keywords=[{"range":"html","word":'','bool':'and','cascader':['and','html'] }]
                }else{
                    this.params.keywords.splice(index,1)
                }
                this.SearchEvent_new(1,0,1)

                // console.log('this.params.keywords:',this.params.keywords)
                // this.params.keywords.splice(index,1)

            },

            deleteYear(){
                this.params.year=''
                this.SearchEvent_new(1,0,1)
            },

            DeleteParam(param){
                delete this.params[param]
                console.log("this.params:",this.params)
                this.SearchEvent_new(1,0,1)
            },

            deleteCause(index){
                let tag=this.param.tag || []
                let arr=this.causeDic[this.param.tags[index]].arr
                tag = tag.filter( (item)=> {
                    return arr.indexOf(item) < 0;
                })

                let checkListArr=this.checkListArr
                checkListArr = checkListArr.filter( (item)=> {
                    return arr.indexOf(item) < 0;
                })
                this.checkListArr=checkListArr
                // this.checkListArr=this.causeDic[data.value].arr

                // this.causeDic[data.value].arr

                this.param.tags.splice(index,1)
                this.param.tag=tag
                this.param.page=1
                this.getList(1)
            },

            deletePrice(index){
                this.param.price.splice(index,1)
            },

   

            SelectArea(e){
                
                window.console.log(e) 
            },
            PickProvince(e){
                window.console.log(e) 
                window.console.log(this.v_dist_placeholders) 
                // this.area_op[0]=e.value
                this.params.region[0]=e.value
                if(e.value=='省'){
                    this.params.region[0]='全部'
                }
        
            } ,
            PickCity(e){
                window.console.log(e) 
                window.console.log(this.v_dist_placeholders) 
                // this.area_op[1]=e.value
                this.params.region[1]=e.value
            } ,
            PickArea(e){
                window.console.log(e) 
                window.console.log(this.v_dist_placeholders) 
                // this.area_op[2]=e.value
                this.params.region[2]=e.value
            },

            handleClose(){
                this.dialogVisible = false
            },

            handleTitleClse(){
                this.title_dialogVisible=false
            },




 

            consulting(){
                window.open('https://webim.bytedance.com/h5/normal/150697/3366acf84aad2c87/')
            },

            MyLikes(){
                this.params.mode='mylikes'
                this.params.myStars=this.myStars
                this.SearchEvent_new()

            },

            CancleMyLikes(){
                this.params.mode=''
                this.SearchEvent_new()
            },

            goTop() {
                // window.scroll(0,0);
                const that = this;
                 
                let timer = setTimeout(() => {
                    let ispeed = Math.floor(-that.scrollTop / 10);
                    document.documentElement.scrollTop = document.body.scrollTop =
                    that.scrollTop + ispeed;
                    if (that.scrollTop === 0) {
                    clearTimeout(timer);
                    }
                }, 10);
            },


       
            modifyTitleHandle(){
                var that=this 
                var data={
                    name:this.titleInput,
                    _id:this.modify_id,
                    whattodo:'change_law_name'
                }
                this.axios.post(this.$root.rootUrl+'admin',data
                ).then(function (res) {

  
                    if(res.status==200){

                        let result=res.data 
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else  if(result.status=='ok'){
                           that.$message({
                                message: 'ok',
                                type: 'success'
                            });
                            // that.dialogVisible=false
                            that.lawtype_dialogVisible=false
                            that.resultList[that.modify_ind]._source.name=that.titleInput
                        }else  if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                            that.dialogVisible=false
                        } 




                   
                    }
                    // loading.close();
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                    // loading.close();
                });

            },


         

            modifyOnshow(){
                var that=this 
                var data={
                    // effectLevel:this.lawtype,
                    _id:this.modify_id,
                    whattodo:'change_law_onshow'
                }
                this.axios.post(this.$root.rootUrl+'admin',data
                ).then(function (res) {

  
                    if(res.status==200){

                        let result=res.data 
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else  if(result.status=='ok'){
                           that.$message({
                                message: 'ok',
                                type: 'success'
                            });
                            // that.lawtype_dialogVisible=false
                         
                            // let obj=that.resultList[that.modify_ind]
                            // obj._source.effectLevel=that.lawtype
                            // that.$set(that.resultList, that.modify_ind, obj);


                        }else  if(result.status=='fail'){
                            that.$message.error(result.failMsg);
                            // that.lawtype_dialogVisible=false
                        } 




                   
                    }
                    // loading.close();
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                    // loading.close();
                });
            }
 



        
        }























        

       


    }
</script>

<style  >
 .dialog_draft{
    height: 70%;
    width:65%;

  }
  .cell{max-height: 94px !important;overflow: auto !important;}
</style>

<style  scoped>
    body{
        background-color: #fff;
        /* background-color: #d4ecff;  */
    }
    
    
    /* page{
     background-color: #dedede;
    } */

    .el-menu-item-group{
        background-color: #f6f8fa!important; 
    }
    /* style="background-color: #f6f8fa!important" */
    .el-menu-item  {
        background-color: #f6f8fa!important; 
    }

    .el-menu-vertical-demo el-menu{
        background-color: #f6f8fa!important; 
    }

    el-menu{
        background-color: #f6f8fa!important; 
    }
    .el-submenu{
        background-color: #f6f8fa!important; 
    }

    .el-table__row{
        max-height: 50px;
        border:1px solid #071018;
    }
 
    
    .searchRow{
        width:98%;
        border:1px solid #071018;
        display: flex;
        flex-direction: row;
        margin-left: auto;
        margin-right: auto;

    }
 
    .mainbox1{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        width: 100%;
 
        margin-left:auto;
        margin-right:auto;
        /* background-color: #f6f8fa!important; */

        /* background-color: rgb(255, 255, 255); */
        /* border:1px solid #98a850;  */
 

    }
    

   .leftside1{
       /* width:17%; */
       /* width: 300px; */
       display: flex;
       flex-direction: column;
       /* justify-content: flex-start; */
        align-items:center;

       height: 100%;
       /* padding-right:10px; */
       /* border-right:1px solid #98a850; */
       /* border:4px solid #50a866; */
        /* align-items: flex-end; */
        margin-left: auto;
 
 
    }

    .leftside1 h3{
        margin-top: 40px;
        font-weight:550;
    }

    .param_wrap{
        display: flex;
        width:90%;
       flex-direction: column;
    }

    .left_wrap{
        width:99%;
        display: flex;
        flex-direction: column;
        height: 600px;
        /* border:1px solid #29cfa6; */
    }
    .left_wrap span{
       margin-top: 8px;
       cursor: pointer;
    }

 .left_wrap span:hover {
       color: rgb(62, 178, 182);
    }

   /* .el-tree-node__content:hover {
        color: rgb(62, 178, 182);
        background: transparent;
    } */

 

    .filter_param{
        display: flex;
        flex-direction: column;
        min-height: 40px;
        width: 100%;
        /* border:1px solid #29cfa6; */
        background-color: rgb(238, 238, 238);
        padding:5px 4px;
    }

    .param_item{
        display: flex;
        flex-direction: row;
       justify-content:   space-between;
        align-items: center;
        /* border:1px solid #29cfa6;  */
    }

    .param_item span{
        font-size:12px;
           
        margin-left: 10px;
    }

    .param_item img{
        width:40px;
        height: 40px;
        
    }


 

     .filter_param h5{
     
        /* border:1px solid #14bb30; */
        margin-bottom: 2px;
       
    }

   .left_insidebox{
       width:99%;
       /* border:1px solid #98a850; */
       margin-left: auto;
       margin-right: auto;
       height: 100%;
       margin-top:4%;
       display: flex;
       flex-direction: row;
       /* align-items: center; */
       justify-content: center;
   }

   .filter{
        display: flex;
       flex-direction: column;
       height: 100%;
        /* border:1px solid #98a850; */
        /* align-items: center; */

        padding:10px;
        /* margin-top: 40px; */

   }
 
 
    .table_column{
       max-height: 200px; 
    }

   .areabox{
       display: flex;
       flex-direction: row;
       height: 40px;
       line-height:40px;
       font-size:15px;
       /* font-weight: lighter; */
       width:100%;
       /* border:1px solid #98a850; */
        

   }

   .topic_official{
    width: 100%;
    min-height: 150px;
    /* border:1px solid #98a850; */
    margin-top:20px;
    display: flex;
    flex-direction: column;
       


   }

   .topic_other{
        width: 100%;
        min-height: 150px;
        /* border:1px dashed #98a850; */
        margin-top:20px;
        display: flex;
        flex-direction: column;
   }
 

    .officialitem{
        margin-top:10px;
        width:100%;
        /* border:1px solid #531143; */
        /* padding-left:35px;  */
    }

    .officialitem  el-button{
        color: #409EFF;
        width:80%;

    }
    .topic_other_inwrap{
        border:1px solid #c7c3c3;
        border-radius: 15px;
        padding-top:5px;
        padding-bottom:15px;
        width:90%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 15px;
        /* text-align: center; */
        min-height: 160px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;

   }
   .topicnumber{
      font-size:11px;
   }

   .topicitem{
        cursor: pointer;
        color: #409EFF;
        font-size:14px;
        width:100%;
        min-height:20px;
        margin-top:10px;
        /* border:1px solid #531143; */
        padding-left:5px; 
        display: flex;
        flex-direction: row;
          /* justify-content: center; */
        align-items:center;
        flex-wrap: wrap;

        

   }

    .rightside{
       width:20%;
       /* border:1px solid #531143; */
        display: flex;
       flex-direction: column;
        /* margin: auto; */
        /* border-left:1px solid rgb(191, 194, 201);   */
   }
   .operation_box{ 
        /* margin-top: 10px; */
        /* border:1px solid #531143; */
        width:95%;
        height: 160px;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items:center;
        /* background-color: #fff; */
        margin-top:10px;


   }
    .operation_item{
        width:37%;
        height: 45%;
        /* border:1px solid #531143; */
        margin: auto;
        font-size:16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        cursor: pointer;

    }
    .operation_item.up{
        height: 60%;
        width:100%;
        /* border:1px solid #531143; */
        font-size:24px;
        text-align: center;
        line-height: 60%;
        /* margin-top:5px; */


    }
    .operation_item.down{
        height: 40%;
        width:100%;
        /* border:1px solid #531143; */
        text-align: center;
        

        
    }

    .calendar_box{
        /* border:1px solid #e225b3; */

    }

    .middle1{
        /* width:75%; */
        width: 100%;
        min-width: 900px;
        /* border:1px solid #e225b3; */
        display: flex;
        flex-direction: column;
        margin-right: auto;
        /* margin-left: auto;
        margin-right: auto; */
        /* border-left:1px solid rgb(191, 194, 201);   */
        /* background-color: ; */
       
    }

    .bottom{
        display: flex;
        margin-top:30px;
        /* border:1px solid #e225b3; */
        height:40px;
        justify-content: center;
        /* align-items: center; */
        /* text-align: center; */
        /* margin-left:auto;
        margin-right:auto; */


    }

    .result_bar{
        font-weight: bold;
        width:95%;
        margin-left:auto;
        margin-right:auto;
     
        display: flex;
        flex-direction: row;
        min-height: 60px;
        /* padding: 5px 0; */
        align-items:center;
        border-bottom:1px solid #dedede;
    }

    .checkListOnShow_bar{
        width: 95%;
        min-height: 40px;
        line-height: 40px;
        /* border:1px solid #b86262 ; */
        margin-left:auto;
        margin-right:auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
    }


    .content_box{
        /* border-bottom:1px solid #dedede; */

        /* border:1px solid #e22121; */
        /* width: 272px; */
        /* margin-top: 25px;
        margin-left: 25px;
        margin-right:25px; */

        margin:20px 25px;
/* 
        margin-left: auto;
        margin-right: auto; */

        width:240px;
        height: 360px;
        /* margin-right: 15px;
        margin-left:15px; */
        /* margin-top:15px; */
        display: flex;
        flex-direction: column;
        
        padding: 2px;
        background-color: #fff;
        cursor: pointer;

    }
    .content_box .head{
        height: 25%;
        width: 100%;
        /* border:1px solid #e22121; */
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        


    }
    .content_box .head .title{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    
 
        /* -webkit-box-align: center;   */
    
       
        font-size: 20px;
        width: 80%;
        /* border:1px solid #e22121; */
        margin-left: auto;
        margin-right: auto;

        height: 40px;
        padding: 0 10px;

     

    }
    .content_box .head .title span{
 
        /* margin-bottom: 10px; */
        /* border:1px solid #26743d; */
        /* height: 100%; */
        width:100%;
        
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        word-break: break-all;
        -webkit-box-orient: vertical;


    }

    .content_box .head .title img{
        width:30px;
        height: 30px;
        margin-right: 10px;
        margin-top: auto;
        margin-bottom: auto;


    }
    .content_box .head .subtitle{
        font-size: 13px;
        margin-right: auto;
        margin-left: auto;
        margin-top: 7px;
    }

    .a4paper{
        height: 60%;
        width:60%;
        /* border:2px solid #10c52e; */
        margin: auto;
        background-color: #fff;
        box-shadow: 5px 5px 10px #888888;
        padding: 4px;
        overflow: hidden;
    }

    .a4paper img{
        height: 100%;
    }
 

    .list_wrap{
        width:95%;
        /* max-width:1480px; */
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        /* justify-content: first baseline; */
        flex-wrap: wrap;
        /* border:1px solid #ee3a3a; */
        min-height: 500px;
        /* padding-top:10px; */

        margin-left: auto;
        margin-right: auto;
        margin-top: 10px;
        background-color: #fff; 

        /* overflow-x: scroll; */
        /* overflow-y: scroll; */
        padding:10px;

        /* padding-bottom: 10px; */
        /* border:1px solid #2c232a; */

    }


    .result_box{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        width: 100%; 
        /* width: auto; */
        /* border:1px solid #98df16; */
    
        /* gap: 5px; */
        /* padding-top: 4px;
        padding-bottom: 10px; */
        /* width:auto; */
    }


    .result_box .up,.down{
        width: 100%;
    }

    .result_box .up {
        padding-left: 10px;
        height: 30px;
        line-height: 30px;
        color: #606266;
        cursor: pointer;
        /* font-weight: bold; */
    }

    .result_box .mid {
        display: flex;
        flex-direction: row;
        padding-left: 10px;
        height: 30px;
        line-height: 30px;
        color: #606266;
        /* border:1px solid #fd25ce;  */
        font-size:14px;
        height: 300px;
        /* color: rgb(61, 131, 136); */
        
    }

    /* mark  */
    .toolbox{ 
        /* border:1px solid #2c232a;  */
        /* width: 240px; */
        /* min-width: 180px ;  */
        height: 60px;
        border-radius: 4px;
        padding: 0 5px 0 10px; 
        display: flex ;
        flex-direction: row;
        background-color: #f6f8fa;
        box-shadow: 0px 0px 5px #dadbdb;
        overflow: hidden;

      
        
        margin:15px;
        /* padding:0 10px; */
        /* margin: 15px 15px 15px auto; */
        /* margin-right: auto; */

    }
    .toolbox a{
        margin-left: 10px;
    }

    .toolbox .p1{
        /* max-width:60px; */
        width: 35px;
        /* border:1px solid #2c232a;  */
    }
    .toolbox .p2{
        /* max-width:200px; */
     
    
        white-space:nowrap;
        overflow: hidden;
        /* border:1px solid #2c232a;  */
        /* width: calc(100% - 35px); */

        /* display: -webkit-box; */
 
    
 
   
    
    }

    .toolbox .p1,.p2{
        display: flex;
        flex-direction: column;
        justify-content: center;
        /* align-items: center; */
        height: 100%;
        /* overflow: hidden; */
        
    }
    .toolbox .p1{
        align-items: center;
    }

    .toolbox .p1 img{
        margin: auto;
        height: 35px;
        width: 35px;
    }

  .toolbox .p2{
      /* padding-left:2px; */
      /* padding-right: 15px; */
    }


    .toolbox .p2 .title{
        color: black;
        font-weight: 800;
        font-size: 15px;
        overflow: hidden;

        /* border:1px solid #2c232a; */

        text-overflow: ellipsis;
        white-space: nowrap;
/* 
         display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; */
 
 
     
    }
    .toolbox .p2 .subtitle{
        color: #383838;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        /* border:1px solid #2c232a; */
    }

 
    .content_box_up{
        height:22%;
        width:100%;
        /* border:1px solid #2c232a; */
        display: flex;
        flex-direction: row;
        align-items:center;
    }
 

    .content_box_down{
        height:72%;
        width:100%;
        /* border:1px solid #39a32f; */
        display: flex;
        flex-direction: row;

    }

    .content_card{
        width: 100%;
        border:1px solid #dedede;
        height:140px;

    }
    .title_content{
        /* cursor: pointer; */
        /* margin-top:0; */
        width:100%;    
        /* border:1px solid #175763; */
        display: flex;
        flex-direction: row;

    }
    .title_content .title{
        /* width:400px; */
        margin-top:5px;
        width:86%;
        overflow: hidden;
        /* border:1px solid #4aa80b; */
        white-space: nowrap;
        cursor: pointer;

        /* color:black;
        text-decoration:none; */
        /* color: cadetblue; */
    }


    .title_content, .mid_content, .bottom_content{
        margin-bottom: 10px;
    }

    .title_content .doclink{
        text-decoration: none;
        color:black;
    }

    .mid_content{
        /* font-weight: lighter; */
      
        font-size: 14px;
        color:#aaa9a9;
        /* border:1px solid #4aa80b; */
    }
    .bottom_content{
        font-size:12px;
        color:#aaa9a9;
        /* border:1px solid #4aa80b; */
    }
    .bottom_content span{
        margin-right: 12px;
    }
    /* .bottom_content el-tag{
        width:100px;
    } */


    .content_box_down.left{
        width:5%;
        height: 100%;
    }
    .content_box_down.right{
        width:95%;
        height: 100%;
    }




    .input-with-select {
        height: 100%;
    }
    .el-select{
        width:80px;
        /* border:1px solid #c41cc4; */
        overflow: hidden;
        line-height: 100%;
 
    }
    /* .Head{
        height:60px;
        padding-left:15px;
        display: flex;
        flex-direction: row;
        align-items:center;
 
        border:1px solid #c41cc4;
        padding: 5px;
    } */


    .mannual{
        display: flex;
        flex-direction: column;

    }

    .mannual span{
        margin-top: 5px;
    }

   ._bottom{
    display: flex;
    flex-direction: row;
    width:100%;
    height: 30px;
    line-height: 30px;
    margin-top:4px;
    /* border:1px solid #50b66f;  */
    font-size:13px;
}
._bottom .left{
    width:65%;
    /* border:1px solid #953ba7;  */
    padding-left: 14px;
    display: flex;
    flex-direction: column;
}
._bottom .right{
    width:35%;
    /* border:1px solid #c9c62e;  */

}


    .el-aside {
        /* width: 180px;
        display: flex;
        flex-direction: row; */
        /* background-color: #D3DCE6; */
        background-color: #fff;
        color: #333;
        text-align: center;
        line-height: 50px;
        /* height: 550px; */
        height: 100%;
        /* border-top:1px solid #185c9c; */
       
        
    }
    

    /* .wrap{
    width:90%;
    margin:auto;
    height: auto;
    border:1px solid #185c9c;
    } */

.tagBar{
    width:100%;
    /* border:1px solid #185c9c; */
    margin:10px auto;
    padding-left:40px;
}

    .separate{
        /* width:100%; */
        height: 35px;
        padding-left: 15px;
        color: #1296db;
        line-height: 35px;
        font-weight: bold;
        font-size:18px;
        /* border:1px solid #185c9c; */
        /* display: inline-block; */
        text-align: left;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        margin-bottom: 0;
        background-color: #E4E7ED;

    }

    /* .separate image{
        width:10px;
        height: 10px;
        border: 1rpx solid #333;
    } */

    .separate p{
        margin-left: 10px;
        height: 32px;
        width:30%;
        border: 1px solid #333; 
    }
    .bluespot{
        width:20px;
        height: 20px;
        border: 1px solid #333;
    }

    .content{
        padding: 10px;
        background-color: #ffffff;
        width: 99%;
        /* margin: 10px; */
        line-height: 28px;
        height: auto;
        text-align: left;
        margin-top:5px;

    }

    .para_tag_box{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        /* padding-top:10px;
        padding-bottom: 10px; */
        border: 1px solid #333;
        line-height: 35px;
        
    }

    .para_tag{
        /* background-color: #409eff; */
        display: flex;
        width: auto;
        margin-left: 15px;
        /* border: 1px solid #333; */
        /* line-height: 45px; */
        padding:10px 15px 10px 15px;
    }

    /* .para_tag span{
        background-color: #8fc4f8;
    } */


    .para_tag_image{
        width:15px;
        height: 15px;
        /* opacity: 0.7; */
        margin-left: 5px;

    }
    .SearchBox{
        display: flex;
        flex-direction: column;
        width: 75%;
        /* border: 1px solid #333;  */
        margin-top:auto;
        margin-bottom:auto;
        padding: auto;
        /* line-height: 60px; */
        height: 90%;
        padding: auto;
    }


 li {
    line-height: normal;
    padding: 7px;
 }
    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }




 .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 100px;
    margin-left: 10px;
    vertical-align: bottom;
  }
    


 /* tableData 的样式 */

.demo-table-expand {
    font-size: 0;

   /* border: 1px solid #d83b3b; */
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }



  .leftmenu{
       border: 1px solid #dedede;
       height: 60px;
       line-height: 60px;
  }

  .condition_mid{
    /* border: 1px solid #dd2222; */
    height: 60px;
    line-height: 52px;

  }


/* 有用 无用 评价标签 */
  .badgeitem {
    margin-top: 10px;
    margin-right: 20px;
    }


 .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    font-size:16px;
  }
  .el-icon-arrow-down {
    font-size: 14px;
  }

 

.header{
    height: 55px;
    width:100%;
    border-bottom:1px solid #f0efef ;
    /* position: absolute; */
    display: flex;
    flex-direction: row;
    /* z-index: 1; */
    color:black;
    align-items: center;
    
    
    /* margin:auto; */
    /* margin-left: 0; */
}
.header a{
    color:black;
    text-decoration: none;
  
}

.header.left{
    height: 100%;
    /* width:70%; */
    width:100%;
    /* border:1px solid #50b66f ; */
 
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 25px;
 
}
.header.left img{
    cursor: pointer;
}

.header.right{
    /* left:40%; */
    height: 100%;
    width:15%;

    /* border:1px solid #ad2ace ;  */
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

}


 .caselist{
    /* border:4px solid #ad2ace ;  */
 }





  .search_class{
        display: flex;
        flex-direction: column;
        align-items: center;
        /* border:1px solid #ca2121; */
        width:100%;
        /* min-width: 600px; */
    }

    .search_line{
        width: 100%;
        display: flex;
   
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        /* border:1px solid #19d4da;  */
        /* height: 40px; */
    }
    .search_line_bt_box{
        width:140px;
        /* background-color: #dedede; */
        text-align: center;
        height: 90%;
        margin-top: auto;
        margin-bottom: auto;
        /* height: 100%;
        line-height: 40px; */

        /* border:2px solid #0a4cdb; */
        /* border:1px solid white;  */
    }
    .search_line_bt{
        width:140px;
    }


    .caseType_style {
        /* margin-top:40px; */
        /* width:750px; */
        /* width:95%; */
        /* height: 80px; */
        margin-left: 40px;
        text-align: center;

        /* height: 40px; */
        vertical-align: center;
        /* top:340px;
        position: absolute; */
        /* margin-left: 60px; */

        /* border:1px solid #50b66f; */
    }



 
 
 

 .right_control{
    min-height:120px;
    width: 80px;
    /* border:1px solid rgb(65, 56, 56); */
    position: fixed;
    bottom: 0;
    right:5px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.colobox{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width:100%;
    height: 80px;
    margin-top:10px;

}
.colobox span{
    font-size:12px;
    margin-top: 4px;;
}


 
.casename{
    color:#67839b;  cursor: pointer;
   
}
 

.sort_bar{
    height: 50px;
    line-height: 50px;
    /* margin-bottom: 10px; */
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    padding-right: 40px;

    /* background-color: blue; */

}

.explain_box{
    width: 95%  ;
    padding-left: 3px;
    height: 40px;
    /* border:1px dashed rgb(65, 56, 56); */
    /* padding-left: 40px; */
    white-space: pre-line;
    margin-left: auto;
    margin-right: auto;

    display: flex;
    flex-direction: row;
    align-items: center;

    /* background-color: #fff; */
}


.navi_item{
cursor: pointer; 
/* border:1px solid rgb(65, 56, 56);  */
height:40px;
line-height:30px;

}
 
.qrcode_box{
    /* width: 90%; */
    /* border:1px solid rgb(65, 56, 56); */
    margin-right: auto;
    margin-left: auto;
    margin-top:20px;

    display: flex;
    flex-direction: row;
    overflow: hidden;
    align-items: center;
    height: 160px;
}

.mini_box{
    /* position: fixed;
    background-color: #1b7bdb; */
    height: 160px;
    z-index: 99;
    width: 140px;
    bottom: 0;
    /* right: 30%; */
    right: 0;
    border-radius: 5px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
    overflow: hidden;

    /* border:1px solid rgb(65, 56, 56); */

}
.mini_box p{
    font-size:14px;
    /* color:snow; */
    overflow: hidden;
}

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    max-width: 200px;
    min-height: 400px;
    background-color: #f6f8fa!important;
    border-right:none ;
    /* border:1px solid rgb(65, 56, 56);  */

  }

    .submenu{
       /* border:1px solid rgb(65, 56, 56);  */
       /* height: 56px; */
       padding-left:0px;
       margin-top: -15px;
       
    }

    .submenu .el-submenu{
        /* height: 56px; */
        
    }

    .clearfix{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-content: center; 
        line-height: 30px;
    }

    .el-submenu .el-menu-item{
        min-width: 100px;
    }
    
 
   
   
</style>

 